<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: [String, Array, Boolean],
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      vnodes.push(h('font-awesome-icon', { props: { icon: icon } }))
    }

    if (title) {
      vnodes.push(h('span', { slot: 'title' }, [title]))
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
</style>
